import { queryKeysInvoice } from '../queryKeys';

export const DLN_ITEM_LINK_MUTATION_KEY = [
  queryKeysInvoice.base(),
  'dln-item-links',
] as const;
